import temp from "./temp";
import user from "./user";

export default {
  active: false,
  ...user,
  ...temp
}
